export const cn = {
    editionInfo: {
        onboarding: {
            slogan: '更好的答案，更快的决策',
            title: '太棒啦，您已经完成首次探索！',
            description: '',
            tryExperience: '请选择您的版本开始体验',
            tryExperienceTrial: '您正在体验企业版试用',
            tryExperiencePremium: '您已经是拥有全部高级功能的企业版用户啦',
            buttonText: '开始使用',
            trial: '限时免费试用{days}天',
        },
        trialEnd: {
            title: '您的试用已结束',
            description: '现在，您可以继续使用基础版，或者升级至企业版，解锁更多强大功能，享受更流畅的使用体验。',
            tryExperience: '选择适合您的版本',
        },
        tryPremium: {
            title: '升级至企业版',
            description: '抱歉，当前版本不支持此功能哦。请升级以解锁更多强大功能！',
            tryExperience: '选择适合您的版本',
            recommend: '推荐',
        },
    },
    editionTag: {
        trial: '试用倒计时：<span class="text-red-500 font-[600]">{days}</span> <span class="text-black">天</span>',
        expire: '试用即将到期',
        freemium: '尝试高级版',
        upgrade: '升级',
    },
    packageDiff: {
        current: '当前订阅',
        overlimit: {
            header: {
                title: '您的使用次数已达上限',
                description: '您可以升级套餐，解锁更多使用次数和高级功能哦。',
            },
            title: 'Eureka',
            features: [
                '一站式轻松获取技术信息',
                '多角度探索技术解决方案',
                '高效完成FMEA分析',
                '全方面技术预研和监控洞察',
                '快速验证方案创新性和撰写交底书'
            ],
            recommend: '推荐',
            buttonText: '升级',
        },
        trialEnd: {
            title: '很抱歉，您的 {packages} 试用已到期',
            upgrade: '您可以升级套餐，解锁更多使用次数和高级功能哦～',
            upgradeButton: '前往升级',
            continueButton: '继续使用',
        },
        muti: {
            title: '升级',
            description: '升级至企业版本，解锁更多功能。',
            expire: '{package} 倒计时 {days} 天',
            buttonText: '升级',
        },
        free: {
            title: '基础版',
            description: '帮助研发用户高效解决技术问题，满足基本研发需求。',
            price: '0',
            buttonText: '继续使用',
            features: [
                '技术信息探索 3次/月',
                '技术预研报告 1次/年',
                '订阅专家技术库 10个'
            ],
        },
        singleAirUpgrade: {
            title: '企业版',
            description: '升级至企业版本，解锁更多功能，享受以下专属体验：',
            buttonText: '升级',
            features: [
                '技术方案探索',
                '设计失效分析',
                '技术问答',
                '技术项目预研报告',
                '技术监控'
            ],
        },
        premium: {
            title: '企业版',
            description: '升级至企业版本，解锁所有核心功能，显著提升您的使用体验。',
            price: '100',
            buttonText: '升级',
            features: [
                '技术方案探索',
                '设计失效分析',
                '技术信息探索 1000次/月',
                '技术项目预研报告 20次/年',
                '订阅专家技术库 20个'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: '今年使用：{0}/{1}次',
        DIMENSION_MONTH: '今月使用：{0}/{1}次',
        DIMENSION_DAY: '今日使用：{0}/{1}次',
        title: '已生成',
        technical_research: '技术预研报告',
        tech_seek: '技术信息问答​',
        tech_mind: '技术方案探索',
        material_mind: '技术方案探索',
        tech_fmea: '技术失效分析',
    },
}

export const en = {
    editionInfo: {
        onboarding: {
            slogan: 'Better answers, faster decisions',
            title: 'Congratulations',
            description: 'You have completed your first exploration',
            tryExperience: 'Choose your version to begin your experience.',
            tryExperienceTrial: 'You are currently experiencing the Enterprise Edition trial.',
            tryExperiencePremium: 'Awesome! You’re an Enterprise user with all premium features.',
            buttonText: 'Start Now',
            trial: 'Limited free trial {days} days',
        },
        trialEnd: {
            title: 'Trial has ended',
            description: 'Your trial has expired. You will now only have access to the basic version. If you wish to continue using the premium version, please click Upgrade.',
            tryExperience: 'Select the version that suits you best.',
        },
        tryPremium: {
            title: 'Upgrade to unlock the Premium experience',
            description: 'This feature is not available in your current version. Please upgrade.',
            tryExperience: 'Select the version that suits you best.',
            recommend: 'Recommend',
        },
    },
    editionTag: {
        trial: 'Remaining trial time: <span class="text-red-500 font-[600]">{days}</span> <span class="text-black">days</span>',
        expire: 'Trial is about to expire',
        freemium: 'Try Premium',
        upgrade: 'Upgrade',
    },
    packageDiff: {
        current: 'Current subscription',
        overlimit: {
            header: {
                title: 'You\'ve reached the usage limit',
                description: 'Upgrade your plan to access additional uses and premium features.',
            },
            title: 'Eureka',
            features: [
                'Instant access to AI-curated technical knowledge.',
                'Explore intelligent solutions with multi-perspective analysis.',
                'Rapid and accurate FMEA evaluation.',
                'Utilize AI-driven pre-research and monitoring for enhanced decision-making.',
                'Rapidly evaluate solution innovation and draft disclosures.'
            ],
            recommend: 'Recommendation',
            buttonText: 'Upgrade',
        },
        trialEnd: {
            title: 'We are sorry, your {packages} trial has expired.',
            upgrade: 'You can upgrade your plan to unlock more usage and premium features!',
            upgradeButton: 'Upgrade',
            continueButton: 'Continue',
        },
        muti: {
            title: 'Upgrade',
            description: 'Enhance your experience by unlocking more advanced features and functionalities.',
            expire: '{package} – {days} Days Left in Your Trial',
            buttonText: 'Upgrade',
        },
        free: {
            title: 'Basic',
            description: 'Helps R&D users efficiently solve technical issues and meet basic needs.',
            price: '0',
            buttonText: 'Keep basic version',
            features: [
                'Scope problem 3 times/month',
                'Quick research 1 time/year',
                'Subscribe to expert library 10'
            ],
        },
        singleAirUpgrade: {
            title: 'Premium',
            description: 'Enhance your experience by unlocking more advanced features and functionalities. ',
            buttonText: 'Upgrade',
            features: [
                'Find solutions',
                'Evaluate Feasibility',
                'Technical Q&A',
                'Quick Research',
                'Monitor Landscape'
            ],
        },
        premium: {
            title: 'Enterprise',
            description: 'Upgrade to Enterprise to unlock all features and enhance your experience.',
            price: '100',
            buttonText: 'Upgrade',
            features: [
                'Find solutions to technical problems',
                'Evaluate technical feasibility',
                'Scope technical problems 1,000 times/month',
                'Quick research 20 times/year',
                'Subscribe to expert library 20'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: 'used this year: {0}/{1} times',
        DIMENSION_MONTH: 'used this month: {0}/{1} times',
        DIMENSION_DAY: 'used today: {0}/{1} times',
        title: 'Usage limit',
        technical_research: 'Quick research',
        tech_seek: 'Scope problem',
        tech_mind: 'Find solutions',
        material_mind: '技术方案探索',
        tech_fmea: 'Evaluate feasibility',
    },
}

export const jp = {
    editionInfo: {
        onboarding: {
            slogan: 'より良い答え、より速い決定',
            title: 'おめでとうございます',
            description: '初めての探索を完了しました',
            tryExperience: 'バージョンを選んで、始めてください。',
            tryExperienceTrial: '現在、エンタープライズ版のトライアルを体験中です。',
            tryExperiencePremium: '全機能搭載の企業版ユーザーです！',
            buttonText: '開始使用',
            trial: '期間限定無料トライアル{days}日',
        },
        trialEnd: {
            title: '試用期間が終了しました',
            description: 'あなたの試用期間は終了しました。現在は基本版のみご利用いただけます。プレミアム版を引き続きご利用になりたい場合は、アップグレードをクリックしてください。',
            tryExperience: 'あなたに適したバージョンを選択してください',
        },
        tryPremium: {
            title: 'アップグレードで体験をアンロック',
            description: '現在のバージョンではこの機能は利用できません。アップグレードしてください。',
            tryExperience: '自分に合ったバージョンを選択してください。',
            recommend: '推薦',
        },
    },
    editionTag: {
        trial: 'トライアルカウントダウン：<span class="text-red-500 font-[600]">{days}</span> <span class="text-black">日</span>',
        expire: 'トライアルがまもなく終了します',
        freemium: '企业版試す',
        upgrade: 'アップ',
    },
    packageDiff: {
        current: '現在のサブスクリプション',
        overlimit: {
            header: {
                title: '現在の機能の使用回数の上限に達しました',
                description: 'プランをアップグレードして、より多くの使用回数と高度な機能をアンロックできますよ.',
            },
            title: 'Eureka',
            features: [
                'ワンストップで簡単に技術情報を入手',
                '多角的に技術ソリューションを探求',
                '効率的にFMEA分析を完了',
                '全方位の技術予備調査とモニタリング洞察',
                'ソリューションの革新性を迅速に検証し、開示書類を作成します'
            ],
            recommend: 'おすすめです',
            buttonText: 'アップグレード',
        },
        trialEnd: {
            title: '申し訳ありませんが、あなたの {packages} の試用期間が終了しました。',
            upgrade: 'プランをアップグレードして、より多くの使用回数とプレミアム機能をアンロックできますよ～',
            upgradeButton: 'アップグレードへ移動',
            continueButton: '引き続き使用する',
        },
        muti: {
            title: 'アップグレード',
            description: '企業版にアップグレードして、より多くの機能を解放します。',
            expire: '{package} カウントダウン：{days}日',
            buttonText: 'アップグレード',
        },
        free: {
            title: '基本版',
            description: 'R&Dユーザーの技術問題を効率的に解決し、基本ニーズを満たします。',
            price: '0',
            buttonText: '基本版を維持する',
            features: [
                '技術情報探索 3回/月',
                '技術項目予備調査レポート 1回/年',
                '専門技術ライブラリの購読 10'
            ],
        },
        singleAirUpgrade: {
            title: 'エンタープライズ版',
            description: '上級バージョンにアップグレードして、より多くの機能をアンロックし、以下の専用体験をお楽しみください：',
            price: '100',
            buttonText: 'アップグレード',
            features: [
                '技術ソリューションの探索',
                '設計失敗分析',
                '技術Q&A',
                '技術プロジェクトの事前調査報告',
                '技術監視'
            ],
        },
        premium: {
            title: '企业版',
            description: '企業版にアップグレードして、全機能を解放し体験を向上。',
            price: '100',
            buttonText: 'アップグレード',
            features: [
                '技術的な問題に対するソリューションを見つける',
                '技術的な実現可能性を評価する',
                '技術的な問題の範囲設定 1,000回/月',
                'クイックリサーチ 20回/年',
                '専門技術ライブラリの購読 20'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: '今年使用：{0}/{1}回',
        DIMENSION_MONTH: '今月使用：{0}/{1}回',
        DIMENSION_DAY: '今日使用：{0}/{1}回',
        title: '使用回数',
        technical_research: '技術予備調査レポート',
        tech_seek: '技術情報問答',
        tech_mind: '技術ソリューション探索',
        material_mind: '技术方案探索',
        tech_fmea: '設計FMEA',
    },
}

export const tw = {
    editionInfo: {
        onboarding: {
            slogan: '更好的答案，更快的決策',
            title: '恭喜',
            description: '您已完成首次探索',
            tryExperience: '請選擇您的版本開始體驗',
            tryExperienceTrial: '您正在體驗企業版試用。',
            tryExperiencePremium: '您已經是擁有全部高級功能的企業版用戶啦',
            buttonText: '開始使用',
            trial: '限時免費試用{days}天',
        },
        trialEnd: {
            title: '您的試用已結束',
            description: '現在，您可以繼續使用基礎版，或者升級至企業版，解鎖更多強大功能，享受更流暢的使用體驗。',
            tryExperience: '選擇適合您的版本',
        },
        tryPremium: {
            title: '升級至企業版',
            description: '抱歉，當前版本不支持此功能哦。請升級以解鎖更多強大功能！',
            tryExperience: '選擇適合您的版本',
            recommend: '推薦',
        },
    },
    editionTag: {
        trial: '試用倒計時：<span class="text-red-500 font-[600]">{days}</span> <span class="text-black">天</span>',
        expire: '試用即將到期',
        freemium: '嘗試高級版',
        upgrade: '升級',
    },
    packageDiff: {
        current: '現在的訂閱',
        overlimit: {
            header: {
                title: '您的使用次數已達上限',
                description: '您可以升級套餐，解鎖更多使用次數和高級功能哦。',
            },
            title: 'Eureka',
            features: [
                '一站式輕鬆獲取技術資訊',
                '多角度探索技術解決方案',
                '高效完成FMEA分析',
                '全方位技術預研和監控洞察',
                '快速驗證方案創新性並撰寫交底書'
            ],
            recommend: '推薦',
            buttonText: '升級',
        },
        trialEnd: {
            title: '很抱歉，您的 {packages} 試用已到期',
            upgrade: '您可以升級套餐，解鎖更多使用次數和高級功能哦～',
            upgradeButton: '前往升級',
            continueButton: '繼續使用',
        },
        muti: {
            title: '升級',
            description: '升級至企業版本，解鎖更多功能。',
            expire: '{package} 倒計時 {days} 天',
            buttonText: '升級',
        },
        free: {
            title: '基礎版',
            description: '幫助研發用戶有效率解決技術問題，滿足基本研發需求。',
            price: '0',
            buttonText: '繼續使用',
            features: [
                '技術信息探索 3次/月',
                '技術項目預研報告 1次/年',
                '訂閱專家技術庫 10個'
            ],
        },
        singleAirUpgrade: {
            title: '企業版',
            description: '升級至企業版本，解鎖更多功能，享受以下專屬體驗：',
            buttonText: '升級',
            features: [
                '技術方案探索',
                '設計失效分析',
                '技術问答',
                '技術項目預研報告',
                '技術監控'
            ],
        },
        premium: {
            title: '企業版',
            description: '升級至企業版本，解鎖所有核心功能，大幅提升您的使用體驗。',
            price: '100',
            buttonText: '升級',
            features: [
                '技術方案探索',
                '設計失效分析',
                '技術信息探索 1000次/月',
                '技術項目預研報告 20次/年',
                '訂閱專家技術庫 20個'
            ],
        },
    },
    usageAmount: {
        DIMENSION_YEAR: '今年使用：{0}/{1}次',
        DIMENSION_MONTH: '今月使用：{0}/{1}次',
        DIMENSION_DAY: '今日使用：{0}/{1}次',
        title: '已生成',
        technical_research: '技術預備調查報告',
        tech_seek: '技術資訊問答',
        tech_mind: '技術方案探索',
        material_mind: '技术方案探索',
        tech_fmea: '技術失效分析',
    },
}
